import { Box } from "@mui/material";

export const DashboardInnerContainer = ({ children }: React.PropsWithChildren) => {
    return <Box pl={2} pr={2} >
        {children}
    </Box>;
};

export const DashboardOuterContainer = ({ children }: React.PropsWithChildren) => {
    return <Box>{children}</Box>;
};
